module.exports = __webpack_public_path__ + "img/smfw.6d03c1b6.png";